import {Component, computed, inject, input} from '@angular/core';
import {DatePipe} from "@angular/common";
import {MentionRendererPipe} from "../../pipes/mention-renderer.pipe";
import {CommentSummary} from '../../../../../api';
import {CurrentUserService} from '../../../../services/current-user.service';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'elcia-todo-comment-item',
  imports: [
    DatePipe,
    MentionRendererPipe,
    TranslatePipe
  ],
  templateUrl: './todo-comment-item.html',
  styleUrl: './todo-comment-item.scss',
})
export class TodoCommentItem {
  currentUserService = inject(CurrentUserService);
  comment = input.required<CommentSummary>();

  isOwnComment = computed(() => this.currentUserService.currentUser()?.id === this.comment().createdById)
}
